<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Relatórios</p>
        </div>

        <div class="muven-content">
            <Loading page v-if="loading" />        

	    <ReportGeneratorFilterCmp 
	    	ref="reportGeneratorFilterCmp"
		@submit="generateReportFileAfterFilter" />

	    <ConfirmationExclusionModalCmp 
                ref="confirmationExclusionModal"
                @confirm="confirmExclusionHandler" />

            <div class="modal" tabindex="-1" role="dialog" id="muven-report-creation-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Solicitação de novo relatório</h5>
                        </div>
                        <div class="modal-body">
			    <div class="row">
					<div class="col-12">
						<div class="muven-tip muven-tip-standalone tip-info mb-3">
							<fa icon="info" class="tip-icon" />
							<p><b>ATENÇÃO!</b></p> 
							<p>O relatório solicitado será analisado e, dependendo da complexidade, será feito um orçamento para que o mesmo seja desenvolvido.</p>
							<p>Assim que o relatório for aceito e implementado, o <b>status</b> ficará como <b>"Pronto para uso"</b> e a geração dos arquivos será liberada, bastando clicar em <b>"Visualizar arquivos"</b>.</p>
						</div>
					</div>
			    </div>	

                            <div class="row">
                                <div class="col-12 form-group">
					<label>Nome do relatório</label>
					<input type="text"
						class="form-control"
						v-model="newReport.name">
				</div>

		 		<div class="col-12 form-group">
					<label>Nome do arquivo a ser gerado</label>
					<input type="text"
						class="form-control"
						v-model="newReport.fileName">
					<small class="text-muted">O arquivo será criado com o sufixo "ano-mês-dia_hora-minuto-segundo.xlsx". Exemplo: nome-arquivo-20210816_151259.xlsx</small>
				</div>

	                       <div class="col-12 form-group">
					<label>Descrição</label>
					<textarea type="text"
						class="form-control"
						v-model="newReport.description"></textarea>
				</div>

				<div class="col-12 form-group">
					<label>Arquivos de exemplo (.PDF, .JPG, .PNG)</label>
					<input type="file" 
						class="form-control"
						id="report-file-example-list-new-report"
                                        	accept=".pdf,.jpg,.png"
                                            	@change="newExampleFileListForNewReportChosenHandler">
					<small class="text-muted">Caso queira deixar mais claro quais informações devem existir no relatório, adicione alguns arquivos de exemplo.</small>
				</div>
			    </div>
			</div>
			<div class="modal-footer">
				<button class="btn btn-primary"
					@click="requestReportHandler(newReport)"
					:disabled="!newReport.isValid() || !hasExamples(newReport) || requestingReport">
					Enviar solicitação

					<Loading v-show="requestingReport" />
				</button>

				<button class="btn btn-outline-secondary"
					@click="closeReportCreationModal()">
					Fechar
				</button>
			</div>
		    </div>
		</div>
	    </div>

            <div class="modal" tabindex="-1" role="dialog" id="muven-report-modification-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Atualização de relatório</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
					<label>Nome do relatório</label>
					<input type="text"
						class="form-control"
						v-model="chosenReport.name">
				</div>

		 		<div class="col-12 form-group">
					<label>Nome do arquivo a ser gerado</label>
					<input type="text"
						class="form-control"
						v-model="chosenReport.fileName">
					<small class="text-muted">O arquivo será criado com o sufixo "ano-mês-dia_hora-minuto-segundo.xlsx". Exemplo: nome-arquivo-20210816_151259.xlsx</small>
				</div>

	                       <div class="col-12 form-group">
					<label>Descrição</label>
					<textarea type="text"
						class="form-control"
						v-model="chosenReport.description"></textarea>
				</div>

				<div class="col-12 form-group" v-show="chosenReport.hasExamples()">
					<label>Arquivos</label>
					<div class="report-file-container">
						<div class="report-file-with-style" v-for="(fileExample, index) in chosenReport.example" :key="index">
							<fa icon="trash-alt" class="report-file-delete-icon" 
								v-show="!fileExample.loadingListAction"
								@click="deleteReportExample(chosenReport, fileExample)" />

							<fa icon="sync-alt" class="report-file-loading-icon" 
								spin
								v-show="fileExample.loadingListAction" />

							<fa icon="file-alt" class="report-file-file-example-icon" />

							<p>Arquivo {{index + 1}} <a :href="fileExample.url" target="_blank"><fa icon="external-link-alt" class="muven-external-link ml-1 text-muted" /></a> </p>
						</div>
					</div>
				</div>

				<div class="col-12 form-group" v-show="!chosenReport.hasExamples()">
					<label>Arquivos de exemplo (.PDF, .JPG, .PNG)</label>
					<input type="file" 
						class="form-control"
						id="report-file-example-list-chosen-report"
                                        	accept=".pdf,.jpg,.png"
                                            	@change="newExampleFileListForChosenReportChosenHandler">
					<small class="text-muted">Caso queira deixar mais claro quais informações devem existir no relatório, adicione alguns arquivos de exemplo.</small>
				</div>
			    </div>
			</div>
			<div class="modal-footer">
				<button class="btn btn-primary"
					@click="uppdateReportHandler(chosenReport)"
					:disabled="!chosenReport.isValid() || !hasExamples(chosenReport) || updatingReport">
					Gravar

					<Loading v-show="updatingReport" />
				</button>

				<button class="btn btn-outline-secondary"
					@click="closeReportModificationModal()">
					Fechar
				</button>
			</div>
		    </div>
		</div>
	    </div>

            <div class="mb-3" v-if="!loading">
                <div>
                    <button type="button" 
                        class="btn btn-primary"
                        @click="showReportCreationModal()">
                        Solicitar novo relatório
                    </button>
                </div>
            </div>
	    
            <NothingFound v-if="nothingToShow" />

            <div v-if="!loading && !nothingToShow">
                <div class="table-responsive">
                    <table class="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Arquivo</th>
                                <th class="big-status-col">Status</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(report, index) in reportList" :key="index">
                                <td>{{report.name}}</td>
                                <td>{{report.fileName}}.xlsx</td>
				<td>
				    <span class="muven-td-icon">
                                        <fa icon="check-circle" 
                                            v-if="report.isStatusDone()"
                                            class="text-success" />

                                        <fa icon="check-circle" 
                                            v-if="report.isStatusWorking()"
                                            class="text-success" />

                                        <fa icon="hourglass-half" 
                                            v-if="report.isStatusRequested()"
                                            class="text-muted" />
                                    </span>
                                    <span>{{report.getStatusDescription()}}</span>
				</td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!report.loadingListAction" />
                                        <fa icon="sync-alt" spin v-show="report.loadingListAction" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <router-link class="dropdown-item"
                                            :to="detailUrl(report)"
                                            v-show="report.isStatusDone() || report.isStatusWorking()">
                                            <fa icon="folder-open" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Visualizar arquivos</span>
                                        </router-link>

                                        <span class="dropdown-item"
                                            v-show="(report.isStatusDone() || report.isStatusWorking()) && !report.hasFilter()"
                                            @click="generateReportFile(report)">
                                            <fa icon="file-download" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Gerar arquivo</span>
                                        </span>

                                        <span class="dropdown-item"
                                            v-show="(report.isStatusDone() || report.isStatusWorking()) && report.hasFilter()"
                                            @click="openFilterModalBeforeGeneratingReportFile(report)">
                                            <fa icon="file-download" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Gerar arquivo</span>
                                        </span>

                                        <p class="dropdown-divider" v-show="(report.isStatusDone() || report.isStatusWorking()) && !report.isPublic()"></p>

                                        <span class="dropdown-item"
                                            v-show="!report.isPublic()"
                                            @click="showReportModificationModal(report)">
                                            <fa icon="edit" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Editar</span>
                                        </span>

                                        <p class="dropdown-divider" v-show="!report.isPublic()"></p>

                                        <span class="dropdown-item muven-action-danger"
                                            v-show="!report.isPublic()"
                                            @click="openConfirmationExclusionModal(report)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Excluir relatório</span>
                                        </span>
                                    </div>
				</td>
			     </tr>
			</tbody>
		    </table>
		</div>
	     </div>		
	</div>
    </div>
</template>

<script>
import reportService from '@/report/services/ReportService'
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import ConfirmationExclusionModalCmp from '@/utils/components/ConfirmationExclusionModalCmp'
import ModalService from '../../utils/services/ModalService'
import { ReportModel } from '../models/ReportModel'
import { cloneDeep } from 'lodash'
import { fileToBase64 } from '../../utils/helpers/FileHelper'
import { ReportFileModel } from '../models/ReportFileModel'
import ReportGeneratorFilterCmp from '../components/ReportGeneratorFilterCmp.vue'

const ID_REPORT_CREATION_MODAL = '#muven-report-creation-modal'
const ID_REPORT_MODIFICATION_MODAL = '#muven-report-modification-modal'

export default {
	name: 'ReportListView',
	components: {
        	ConfirmationExclusionModalCmp,
		ReportGeneratorFilterCmp,
	},
	filters: {
		infoOrPlaceholder,
	},
	data() {
		return {
			loading: true,
			requestingReport: false,
			updatingReport: false,
			reportList: [],
			newReport: new ReportModel(),
			chosenReport: new ReportModel(),
			newFileExampleListForNewReport: [],
			newFileExampleListForChosenReport: [],
		}
	},
	async mounted() {
		try {
			this.reportList = await reportService.getReportList()
			this.loading = false
		} catch (err) {
			this.$floatingAlert.error({
				message: err.message,
			})
		}
	},
	methods: {
		async generateReportFile(report, filterForm) {
			report.loadingListAction = true

			try {
				await reportService.generateReportFile(report.getId(), filterForm)

				if (report.hasFilter()) {
					this.$refs.reportGeneratorFilterCmp.close()
				}

				if (report.isPublic()) {
					this.loading = true
					this.reportList = await reportService.getReportList()
					this.loading = false
				}

				this.$floatingAlert.info({
					title: '',
					message: `O arquivo do relatório <b>${report.name}</b> já está sendo processado. Assim que estiver pronto para uso, lhe enviaremos uma notificação.`,
				})
			} catch(err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			report.loadingListAction = false
		},
		showReportCreationModal() {
			this.newReport = new ReportModel()
			document.getElementById('report-file-example-list-new-report').value = null
			ModalService.show(ID_REPORT_CREATION_MODAL)
		},
		closeReportCreationModal() {
			ModalService.hide(ID_REPORT_CREATION_MODAL)
		},
		showReportModificationModal(report) {
			this.chosenReport = cloneDeep(report)
			document.getElementById('report-file-example-list-chosen-report').value = null
			ModalService.show(ID_REPORT_MODIFICATION_MODAL)
		},
		openFilterModalBeforeGeneratingReportFile(report) {
			this.chosenReport = cloneDeep(report)
			this.$refs.reportGeneratorFilterCmp.show(report)
		},
		async generateReportFileAfterFilter(filterForm) {
			await this.generateReportFile(this.chosenReport, filterForm)
		},
		closeReportModificationModal() {
			ModalService.hide(ID_REPORT_MODIFICATION_MODAL)
		},
		async requestReportHandler(report) {
			this.requestingReport = true

			try {
				const requestedReport = await reportService.requestReport(report)

				for (const fileExample of this.newFileExampleListForNewReport) {
					await reportService.uploadReportExampleList(requestedReport.getId(), [fileExample])
				}

				this.reportList.push(requestedReport)
				ModalService.hide(ID_REPORT_CREATION_MODAL)
				this.$floatingAlert.info({
					title: 'Solicitação de relatório recebida',
					message: 'Recebemos a sua solicitação de um novo relatório e assim que tivermos uma posição, lhe enviaremos uma notificação.',
				})
			} catch(err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			this.requestingReport = false
		},
		async uppdateReportHandler(report) {
			this.updatingReport = true

			try {
				const updatedReport = await reportService.updateReport(report.getId(), report)
				let updatedReportWithExample = null

				for (const fileExample of this.newFileExampleListForChosenReport) {
					updatedReportWithExample = await reportService.uploadReportExampleList(updatedReport.getId(), [fileExample])
				}
				
				this.reportList.forEach((r, index) => {
					if (!updatedReportWithExample) {
						if (r.id === updatedReport.id) {
							this.reportList[index] = updatedReport
							return
						}
					} else {
						if (r.id === updatedReportWithExample.id) {
							this.reportList[index] = updatedReportWithExample
							return
						}					
					}
				})
				ModalService.hide(ID_REPORT_MODIFICATION_MODAL)
			} catch (err) {
				this.$floatingAlert({
					message: err.message,
				})
			}

			this.updatingReport = false
		},
		openConfirmationExclusionModal(report) {
			const info = {
				id: report.id,
				title: 'Exclusão de relatório',
				message: `Tem certeza que deseja excluir o relatório <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${report.name}</span>?`,
			}

			this.$refs.confirmationExclusionModal.open(info)
		},
		async confirmExclusionHandler({id}) {
			try {
				await reportService.deleteReport(id)

				for (let i = 0; i < this.reportList.length; i++) {
					if (this.reportList[i].id === id) {
						this.$floatingAlert.success({
							message: `Relatório <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${this.reportList[i].name}</span> excluído com sucesso.`,
						})
						this.reportList.splice(i, 1)
						break
					}
				}
			} catch (e) {
				this.$floatingAlert.error({
					message: e.message,
				})
			}

			this.$refs.confirmationExclusionModal.close()
		},
		async newExampleFileListForNewReportChosenHandler({target}) {
			for (const file of target.files) {
				const fileText = await fileToBase64(file);                
				const fileTextSplit = fileText.split(";base64,");
				const reportFile = new ReportFileModel({
					filename: file.name,
					content: fileTextSplit[1],
				})
				this.newFileExampleListForNewReport.push(reportFile)
			}
		},
		async newExampleFileListForChosenReportChosenHandler({target}) {
			for (const file of target.files) {
				const fileText = await fileToBase64(file);                
				const fileTextSplit = fileText.split(";base64,");
				const reportFile = new ReportFileModel({
					filename: file.name,
					content: fileTextSplit[1],
				})
				this.newFileExampleListForChosenReport.push(reportFile)
			}
		},
		async deleteReportExample(report, fileExample) {
			fileExample.loadingListAction = true

			try {
				await reportService.deleteReportExample(report.id, fileExample.url)

				for (let i = 0; i < report.example.length; i++) {
					if (report.example[i].url === fileExample.url) {
						report.example.splice(i, 1)
						break
					}
				}
			} catch(err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			fileExample.loadingListAction = false
		},
	},
	computed: {
		nothingToShow() {
			return !this.loading && !this.reportList.length
		},
		detailUrl() {			
			return (report) => {	
				return `/relatorios/${report.getId()}/arquivos`
			}
		},
		hasExamples() {
			return (report) => {
				if (report.isNew()) {
					return !!this.newFileExampleListForNewReport.length
				}

				return !!this.newFileExampleListForChosenReport.length
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.report-file-container {
	overflow: hidden;

	.report-file-with-style {
		position: relative;
		float: left;
		width: 110px;
		height: 140px;
		padding: 16px;
		border: 1px solid var(--border);
		border-radius: 4px;
		background-color: var(--surface-2);
		margin-right: 15px;

		p {
			margin-top: 8px;
			text-align: left;
			color: var(--text-muted);
			font-size: .9em;
		}

		.report-file-delete-icon,
		.report-file-loading-icon {
			position: absolute;
			top: 8px;
			right: 8px;
			color: var(--text-muted);
			transition: color ease .3s;
			cursor: pointer;

			&:hover {
				color: var(--text);
			}
		}

		.report-file-file-example-icon {
			font-size: 5em;
			color: var(--text-disabled);
		}
	}
}
</style>